/**
 * タイポグラフィ
 * フォント、サイズ、ウェイト、行間などのテキストスタイル定義
 *
 * このファイルには以下のカテゴリが含まれます：
 * - フォントファミリー: 使用するフォントの種類
 * - フォントサイズ: Type Scale（サイズの階層）
 * - フォントウェイト: 文字の太さ
 * - 行間: テキストの行の高さ
 * - 文字間隔: レターススペーシング
 * - 見出しスタイル: h1〜h6の定義済みスタイル
 */

/**
 * タイポグラフィ - 階層的で読みやすいフォントシステム
 */
export const TYPOGRAPHY = {
  // フォントファミリー
  fontFamily: {
    primary:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    secondary: 'Georgia, "Times New Roman", Times, serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    japanese: '"Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif',
  },

  // フォントサイズ（Type Scale）
  fontSize: {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    base: '1rem', // 16px
    md: '1rem', // 16px - base と同じ
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem', // 48px
    '6xl': '3.75rem', // 60px
    // 従来との互換性
    xxl: '1.5rem', // 24px
  },

  // フォントウェイト
  fontWeight: {
    thin: '100',
    extralight: '200',
    light: '300',
    normal: '500', // デフォルトを500に変更（より読みやすく）
    medium: '600', // mediumを600に変更
    semibold: '700', // semiboldを700に変更
    bold: '800', // boldを800に変更
    extrabold: '900',
    black: '900',
  },

  // 行間
  lineHeight: {
    none: '1',
    tight: '1.25',
    snug: '1.375',
    normal: '1.5',
    relaxed: '1.625',
    loose: '2',
  },

  // 文字間隔
  letterSpacing: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },

  // 見出しのスタイル設定
  headings: {
    h1: {
      fontSize: '3rem',
      fontWeight: '800', // より太く
      lineHeight: '1.25',
      letterSpacing: '-0.025em',
    },
    h2: {
      fontSize: '2.25rem',
      fontWeight: '700', // より太く
      lineHeight: '1.25',
      letterSpacing: '-0.025em',
    },
    h3: {
      fontSize: '1.875rem',
      fontWeight: '700', // より太く
      lineHeight: '1.375',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: '700', // より太く
      lineHeight: '1.375',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: '600',
      lineHeight: '1.5',
    },
    h6: {
      fontSize: '1.125rem',
      fontWeight: '600',
      lineHeight: '1.5',
    },
  },
} as const;
